import React, { useState, useRef } from 'react';
import { Breadcrumb, Row, Col } from 'antd';
import { useLocation, useNavigate, Link } from 'react-router-dom'
const CommentsDetailsPage = (props) => {
    const navigate = useNavigate();
    const location = useLocation()
    const { state } = location
    const ref = useRef(null);
    const [width, setWidth] = useState(0);
    const [fileList, setFileList] = useState([]);
    React.useEffect(() => {
        setWidth(ref.current.offsetWidth);
        window.history.pushState(null, null, document.URL);
        window.onpopstate = function (PopStateEvent) {
            window.history.pushState(null, null, document.URL);
            onStartScore()
        };
        return () => {
            // 回退事件只用于当前组件，则需要在组件销毁时把回退事件销毁
            window.onpopstate = null;
        };

    }, [])

    function onStart() {
        props.setNewKey('developerCenter/scoreOrComments/myVitals/android')
        navigate('/developerCenter/scoreOrComments/myVitals/android')
    }
    function onStartScore() {
        if (state.app === 'MyVitals4.0') {
            if (state.platform === 'Android') {
                props.setNewKey('developerCenter/scoreOrComments/myVitals/android')
                navigate('/developerCenter/scoreOrComments/myVitals/android', {
                    replace: false,
                    state: {
                        ignore: state.ignore,
                        version: state.version,

                        startTime: state.startTime,
                        endTime: state.endTime,
                        startTimeString: state.startTimeString,
                        endTimeString: state.endTimeString,

                        page: state.page,
                        showSize: state.showSize,

                    }
                })
            } else {
                props.setNewKey('developerCenter/scoreOrComments/myVitals/ios')
                navigate('/developerCenter/scoreOrComments/myVitals/ios', {
                    replace: false,
                    state: {
                        ignore: state.ignore,
                        version: state.version,

                        startTime: state.startTime,
                        endTime: state.endTime,
                        startTimeString: state.startTimeString,
                        endTimeString: state.endTimeString,

                        page: state.page,
                        showSize: state.showSize,

                    }
                })
            }
        } else if (state.app === 'iGluco') {
            if (state.platform === 'Android') {
                props.setNewKey('developerCenter/scoreOrComments/iGluco/android')
                navigate('/developerCenter/scoreOrComments/iGluco/android', {
                    replace: false,
                    state: {
                        ignore: state.ignore,
                        version: state.version,

                        startTime: state.startTime,
                        endTime: state.endTime,
                        startTimeString: state.startTimeString,
                        endTimeString: state.endTimeString,

                        page: state.page,
                        showSize: state.showSize,

                    }
                })
            } else {
                props.setNewKey('developerCenter/scoreOrComments/iGluco/ios')
                navigate('/developerCenter/scoreOrComments/iGluco/ios', {
                    replace: false,
                    state: {
                        ignore: state.ignore,
                        version: state.version,

                        startTime: state.startTime,
                        endTime: state.endTime,
                        startTimeString: state.startTimeString,
                        endTimeString: state.endTimeString,

                        page: state.page,
                        showSize: state.showSize,

                    }
                })
            }
        }

    }
    return (
        <div style={{ height: '100%', width: '100%', backgroundColor: 'white', }}>
            {/* 标题头 */}
            <div ref={ref} style={{ padding: '0px', backgroundColor: 'white', borderRadius: '2px', }}>
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                    <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>{'Ratings & Reviews'}</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStartScore} style={{ fontSize: '12px' }}>{state.app + ' ' + state.platform}</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>Content</a></Breadcrumb.Item>
                </Breadcrumb>

                <div style={Styles.title}>Content</div>
                <div style={{ marginTop: '30px', marginBottom: '25px', height: '1px', width: '100%', backgroundColor: '#F0F2F5' }}></div>
                <Row>
                    <Col style={Styles.itemLeftStyle}>UserName:</Col>
                    <Col style={Styles.itemRightStyle}>{state.userName}</Col>
                </Row>
                <Row>
                    <Col style={Styles.itemLeftStyle}>Score:</Col>
                    <Col style={Styles.itemRightStyle}>{state.score}</Col>
                </Row>
                <Row>
                    <Col style={Styles.itemLeftStyle}>Region/Languane:</Col>
                    <Col style={Styles.itemRightStyle}>{state.region}</Col>
                </Row>
                <Row>
                    <Col style={Styles.itemLeftStyle}>App Version:</Col>
                    <Col style={Styles.itemRightStyle}>{state.appVersion}</Col>
                </Row>
                <Row>
                    <Col style={Styles.itemLeftStyle}>Platform:</Col>
                    <Col style={Styles.itemRightStyle}>{state.platform}</Col>
                </Row>
                <Row>
                    <Col style={Styles.itemLeftStyle}>Create Time:</Col>
                    <Col style={Styles.itemRightStyle}>{state.createdAt.substring(0, 10) + ' ' + state.createdAt.substring(12, 19)}</Col>
                </Row>
                <Row>
                    <Col style={Styles.itemLeftStyle}>Title:</Col>
                    <Col style={Styles.itemRightStyle}>{state.title === null ? '--' : state.title}</Col>
                </Row>

                <Row>
                    <Col style={{ paddingTop: '2px', width: '350px', textAlign: 'right', fontSize: '20px', color: '#3D3D3D', }}>Content:</Col>
                    <Col style={Styles.itemRightStyle}>
                        <div style={{
                            width: width / 5 * 4 - 350, minHeight: '200px', backgroundColor: '#F0F2F5', borderRadius: '2px',
                            paddingTop: '2px', paddingLeft: '4px', paddingRight: '4px'
                        }}>{state.content}</div></Col>
                </Row>
                <Row>
                    <Col style={Styles.itemLeftStyle}>ReplyDate:</Col>
                    <Col style={Styles.itemRightStyle}>{state.replyDate === null ? '--' : state.replyDate}</Col>
                </Row>
                <Row >
                    <Col style={Styles.itemLeftStyle}>ReplyText:</Col>
                    <Col style={Styles.itemRightStyle}>
                        <div style={{
                            width: width / 5 * 4 - 350, minHeight: '200px',
                            paddingLeft: '4px', paddingRight: '4px'
                        }}>{state.replyText === null ? '--' : state.replyText}</div>
                    </Col>
                </Row>
                <div style={{ height: '20px' }}></div>
            </div>
        </div>
    )
}
const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '30px',

    }, itemLeftStyle: {
        width: '350px',
        textAlign: 'right',
        fontSize: '20px',
        color: '#3D3D3D',
    }, itemRightStyle: {
        marginLeft: '30px',
        marginRight: '55px',
        fontSize: '20px',
        color: '#3D3D3D',
    },
}
export default CommentsDetailsPage;